import type { Tags } from "./tags";

const tagFilter =
    (
        tagName: keyof Pick<
            Tags,
            "areas" | "categories" | "custom" | "delivery"
        >,
        tagValue: string,
    ) =>
    (item: { meta: { tags: Tags } } | { tags: Record<string, boolean> }) => {
        if ("meta" in item) {
            return item.meta.tags?.[tagName].includes(tagValue);
        }
        return !!item.tags[tagValue];
    };

const categoryTagFilter = (category: string) =>
    tagFilter("categories", category);
const areaTagFilter = (areaTag: string) => tagFilter("areas", areaTag);
const customTagFilter = (tag: string) => tagFilter("custom", tag);
const deliveryTagFilter = (deliveryTag: string) =>
    tagFilter("delivery", deliveryTag);

export {
    areaTagFilter,
    categoryTagFilter,
    customTagFilter,
    deliveryTagFilter,
    tagFilter,
};
